export default __webpack_public_path__ + "static/media/16.a01c8bf4.svg";